import { render, staticRenderFns } from "./CWordCount.vue?vue&type=template&id=838ebade&scoped=true&"
import script from "./CWordCount.vue?vue&type=script&lang=js&"
export * from "./CWordCount.vue?vue&type=script&lang=js&"
import style0 from "./CWordCount.vue?vue&type=style&index=0&id=838ebade&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838ebade",
  null
  
)

export default component.exports